import { render } from "./Rka.vue?vue&type=template&id=7f31cc92"
import script from "./Rka.vue?vue&type=script&lang=js"
export * from "./Rka.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__